<template>
  <div>
    <!-- <el-row>
      <el-col :span="12" class="mb-3" style="float: right;text-align: end;">
        <el-button type="danger"><a class="link-mock" :href="downloadFile" download>Download Template</a></el-button>
      </el-col>
    </el-row> -->
    <el-row v-loading.body="loading" style="min-height: 150px;" element-loading-text="Loading files">
      <el-table
        striped
        empty-text="No files"
        :data="savedFilesWithReadableDates"
        v-if="loadedFiles && loadedFiles.length">
        <el-table-column
          prop="original_filename"
          label="File"
          align="left"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="created_on"
          label="Date Uploaded"
          align="center">
        </el-table-column>
        <el-table-column
          fixed="right"
          width="100"
          label="Actions"
          align="center">
          <template slot-scope="scope">
            <a :href="scope.row.link" target="_blank"><i class="el-icon-picture m-right-5 green"></i></a>
            <i class="el-icon-circle-cross red delete-btn" @click="deleteAsset(scope.$index, scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div v-else id="nofiles">No files</div>
    </el-row>
    <vue-dropzone
      id="dropzone-import"
      ref="dropzone-import"
      :options="dzOptions"
      @vdropzone-files-added="handleFileUpload"
      @vdropzone-sending="emitSending"
      @vdropzone-success="emitSuccess"
      @vdropzone-error="emitError">
    </vue-dropzone>
    <el-row>
      <span style="float: right" class="mt-3">
        <el-button @click="closeImportModal">Cancel</el-button>
        <el-button type="primary" @click="onSubmit">Submit</el-button>
      </span>
    </el-row>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import { transactionMixins } from '@/Mixins/Transactions'
  import { DateFormatter } from '@/utils/helpers/FormatDate'

  export default {
    components: {
      vueDropzone: vue2Dropzone
    },
    mixins: [ transactionMixins ],
    props: {
      dzOptions: Object,
      transaction: Object,
      downloadFile: String
    },
    data () {
      return {
        loadedFiles: [],
        newForm: undefined,
        url: null,
        loading: false,
        format: '',
        opts: [
          {label: 'PDF', value: 'pdf'},
          {label: 'EXCEL', value: 'excel'}
        ],
        payload: [],
        filename: 'error_import_file.xlsx'
      }
    },
    methods: {
      /**
       * Call this function when adding to the Dropzone queue
       * @param files
       * @return {Promise}
       */
      handleFileUpload (files) {
        if (this.loadedFiles && this.loadedFiles.length) {
          this.$refs['dropzone-import'].removeFile(this.loadedFiles[0].file)
        }
        for (var i = 0; i < files.length; i++) {
          this.loadedFiles = [{file: files[i],
            original_filename: files[i].name,
            size_bytes: files[i].size,
            mime_type: files[i].type
          }]
        }
      },
      /**
       * This catches the file right before sending which means we need to get a signed AWS S3 URL prior to uploading.
       * @param file
       * @param xhr
       * @param formData
       * @return {methods|Component}
       */
      emitSending (file, xhr, formData) {
        for (let [key, value] of this.newForm.entries()) {    // Load our prepared form data into Dropzone's formData
          formData.append(key, value)
        }
        formData.delete('s3ObjectLocation')                   // Delete extraneous keys
        return this.$emit('upload-sending', true)
      },
      /**
       * Reload the list of files
       */
      emitSuccess (file) {
        return this.$emit('upload-success', true)
      },
      emitError (file) {
        this.$emit('upload-error', true)
        return true
      },
      /**
       * Not used
       */
      emitProcessing (file) {
        return this.$emit('upload-processing', true)
      },
      /**
       * Not used
       */
      emitComplete (file) {
        return this.$emit('upload-complete', true)
      },
      /**
       * Emit event when file removed
       */
      emitRemove () {
        this.$emit('upload-remove')
      },
      /**
       * Remove files from Dropzone loader
       */
      removeFiles () {
        this.$refs['dropzone-import'].removeAllFiles()
      },
      /**
       * Delete an asset file
       * @param index
       * @param file
       * @return {boolean}
       */
      deleteAsset (index, file) {
        this.createConfirmationBox('Confirm', 'Really Delete this file? ')
          .then(confirmation => {
            if (confirmation === true) {
              this.loadedFiles = this.loadedFiles.filter(element => {
                return JSON.stringify(element) !== JSON.stringify(file)
              })
              this.$refs['dropzone-import'].removeFile(file.file)
            } else if (confirmation === false) {
              return false
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
     /**
     * on close make variable empty and emit closeImportModal
     */
      closeImportModal () {
        this.loadedFiles = []
        this.removeFiles()
        this.$emit('closeImportModal')
      },
     /**
     * on submit files make api call to upload file
     */
      onSubmit () {
        this.$emit('onSubmitFiles', this.loadedFiles)
        this.loadedFiles = []
        this.removeFiles()
      }
    },
    computed: {
      /**
       * Transforms 'created_on' date from ISO timestamp to YYYY=MM-DD string
       * @return {Array|any[]}
       */
      savedFilesWithReadableDates () {
        return this.loadedFiles.map(v => {
          v.created_on = DateFormatter.formatISODateString(v.lastModified)
          return v
        })
      }
    },
    /**
     * on create make loadedFiles as empty
     */
    created () {
      this.url = this.dzOptions.signingUrl
      this.loadedFiles = []
    },
     /**
     * on mounted make loadedFiles as empty
     */
    mounted () {
      this.loadedFiles = []
    }
  }
</script>

<style scoped>
  .amount { text-align: right; font-weight: bold; }
  .centered { margin: 0 auto; text-align: center; }
  .subtitle { font-size: 1.5em; margin-bottom: 20px }
  .green { color: #13CE66; }
  .red { color: #FF4949; }
  .lt-blue { color: #58B7FF; }
  .m-right-5 { margin-right: 5px; }
  .delete-btn {  cursor: pointer;  }
  #nofiles {
    margin-top: 40px;
    color: lightgrey;
    text-align: center;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FileImport.vue